import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol, ContainerEdit } from '../componentes_generales/componentes_formulario/contenedores/';
import {LabelForm, LabelCabecera, LabelKey, LabelValor } from '../componentes_generales/componentes_formulario/labels/';
import InputSearch from '../componentes_generales/componentes_formulario/inputs/inputsearch';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { formatearFechaMoment_a_String, formatearNumeroDecimal, completar_String } from '../../funciones_globales/format';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { validarFechaTransaccionSeleccionada, validarPermisoAcceso, validarCampoString, validarFechaMomentEnFormatoString, validarJSON } from '../../funciones_globales/utils';
import { multiplicarDecimales } from '../../funciones_globales/operacionesMatematicas';
import global_axios from '../../funciones_globales/interaccionapi';
import moment from 'moment';
import { cargar_Factura, inicializarFactura, seleccionar_PuntoFacturacion } from '../../actions/ventas/act_ven02';
import { seleccionar_NumeroComprobante, seleccionar_NumeroComprobanteAlterno } from '../../actions/generales/act_gen04';
import { cargar_NotaCreditoPorCodigo, cargar_NotaCreditoPorNumero, inicializarNotaCredito  } from '../../actions/clientes/act_cli04';
import { cargar_NotaDebitoPorCodigo, cargar_NotaDebitoPorNumero, inicializarNotaDebito } from '../../actions/clientes/act_cli05';
import NumeroComprobante from '../componentes_generales/numeroComprobante/numeroComprobante';
import NumeroComprobanteAlterno from '../componentes_generales/numeroComprobante/numeroComprobanteAlterno';
import PuntoFacturacion from '../ventas/puntoFacturacion';
import { getItemDatosSesion, getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';
import { obtenerSecuencial } from '../../funciones_globales/parametros';
import styled from 'styled-components';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';

const ContenedorInfoDocModif = styled.div`
  background-color: #f9f9f9;
  border: 1px solid #cfd8dc;
  padding: 5px;
  margin-bottom: 5px;
`;

const ContenedorBotones = styled.div`
  margin-top: 10px;
`;

const ContenedorDocModif = styled.div`  
  display: ${props => props.isVisible?'block':'none'};
`;

class FormCli04 extends React.Component{
  
  constructor(props) {
    super(props);
    this.state = {
      operacion: 'G',
      secuencialNCredito: '',
      idNotaCredito: '',
      idCliente: '',
      idVendedor: '',
      fechaNotaCredito: null,
      tipo: 'I',
      docModificado: 'F',
      conceptosNCredito: [],
      conceptosNCreditoPorTipo: [],
      idDocModificado: '',
      notaDebitoInterna: '',
      concepto_sel: null,
      observacion: '',      
      subtotalGravaIva: null,
      subtotalNoGravaIva: null,
      porcentajeIva: null,
      valorIva: null,
      total: null,
      permitirValorGravaIva: false
    };

    this.handleInputChange=this.handleInputChange.bind(this);
    this.limpiar=this.limpiar.bind(this);
    this.getNotaCreditoById=this.getNotaCreditoById.bind(this);
    this.guardarNotaCredito=this.guardarNotaCredito.bind(this);
    this.getDocumentoAModificar=this.getDocumentoAModificar.bind(this);
    this.calculoValores=this.calculoValores.bind(this);
    this.seleccConceptosNCreditoPorTipo=this.seleccConceptosNCreditoPorTipo.bind(this);
    this.inicializarDocumentos=this.inicializarDocumentos.bind(this);
    this.imprimirNotaCredito=this.imprimirNotaCredito.bind(this);
    this.anularNotaCredito=this.anularNotaCredito.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });

    if (name==='tipo'){
      this.seleccConceptosNCreditoPorTipo(value);
    }
  }
  
  componentDidMount(){
    Promise.all([
      this.cargarCatalogoConceptosNCredito(),
      obtenerSecuencial('Credito'),
      this.props.generar_LogAuditoriaIngresoForm('0104'),
    ])
    .then(([conceptosNotaCredito, secuencialNotaCred]) => {
      let fechaProceso = getFechaProcesoPorModulo('01');
      this.setState({
        conceptosNCredito: conceptosNotaCredito,
        secuencialNCredito: completar_String((secuencialNotaCred.codigo-1).toString(), '0', 6),
        fechaNotaCredito: moment(fechaProceso, 'DD/MM/YYYY')
      });

      this.seleccConceptosNCreditoPorTipo(this.state.tipo);
      this.props.inicializarFactura();
      this.props.inicializarNotaCredito();
      this.props.inicializarNotaDebito();
    })
    .catch(error => {      
      alert(error.response?error.response.data.msg:error);
    });
  }

  componentWillUnmount(){
    this.props.generar_LogAuditoriaSalidaForm('0104');
  }

  calculoValores(){    
    let subtotalGravaIva = this.state.subtotalGravaIva===null?0:(this.state.subtotalGravaIva.toString().trim()==='' || isNaN(this.state.subtotalGravaIva)?0:this.state.subtotalGravaIva);
    let subtotalNoGravaIva = this.state.subtotalNoGravaIva===null?0:(this.state.subtotalNoGravaIva.toString().trim() ==='' || isNaN(this.state.subtotalNoGravaIva)?0:this.state.subtotalNoGravaIva);    
    let porcentajeIva = this.state.porcentajeIva===null?0:(isNaN(this.state.porcentajeIva)?0:this.state.porcentajeIva);
    let valorIva = parseFloat(multiplicarDecimales(subtotalGravaIva, (porcentajeIva/100))).toFixed(2);
    let total = parseFloat(parseFloat(subtotalGravaIva)+parseFloat(valorIva)+parseFloat(subtotalNoGravaIva)).toFixed(2);
    this.setState({valorIva, total});
  }

  inicializarPuntoFacturacionDeNumerosComprobantes(){
    let puntoFacturacionDefault;

    for(let i=0; i<this.props.puntosFacturacion.length; i++){
      if (this.props.puntosFacturacion[i].EsDefault==='S'){
          puntoFacturacionDefault = this.props.puntosFacturacion[i];
          break;
      }
    }
    let numeroComprobante = puntoFacturacionDefault.Establecimiento + '-' + puntoFacturacionDefault.PtoEmision;
    this.props.seleccionar_NumeroComprobante(numeroComprobante);
    this.props.seleccionar_NumeroComprobanteAlterno(numeroComprobante);
    this.props.seleccionar_PuntoFacturacion(puntoFacturacionDefault.Codigo);
  }

  inicializarDocumentos(inicializaPtoFac){
    this.props.inicializarFactura();
    this.props.inicializarNotaCredito();
    this.props.inicializarNotaDebito();
    if(inicializaPtoFac){
      this.inicializarPuntoFacturacionDeNumerosComprobantes();
    }
    this.setState({notaDebitoInterna: ''});
  }

  limpiar(){    
    this.inicializarDocumentos(true);
    Promise.all([
      obtenerSecuencial('Credito')
    ])
    .then(([secuencialNotaCred])=>{
      let fechaProceso = getFechaProcesoPorModulo('01');
      this.setState({
        operacion: 'G',
        idNotaCredito: '',
        secuencialNCredito: completar_String((secuencialNotaCred.codigo-1).toString(), '0', 6),
        idCliente: '',
        idVendedor: '',
        fechaNotaCredito: moment(fechaProceso, 'DD/MM/YYYY'),
        tipo: 'I',
        docModificado: 'F',
        idDocModificado: '',
        notaDebitoInterna: '',
        concepto_sel: null,
        observacion: '',
        subtotalGravaIva: null,
        subtotalNoGravaIva: null,
        porcentajeIva: null,
        valorIva: null,
        total: null,
        permitirValorGravaIva: false
      });

      this.seleccConceptosNCreditoPorTipo(this.state.tipo);
    });
  }

  getDocumentoAModificar(){
    
    if(this.state.docModificado==='F'){

      if (!validarCampoString(this.props.numeroComprobante, 17)){
        alert('No ha especificado el No. de Documento a modificar correctamente.');
        return;
      }

      let establec = this.props.numeroComprobante.slice(0,3);
      let ptoEmision = this.props.numeroComprobante.slice(4,7);
      let secuencial = this.props.numeroComprobante.slice(8);

      this.props.cargar_Factura(establec, ptoEmision, secuencial)
      .then(()=>{
        if (validarJSON(this.props.facturaSel)){
          this.setState({ idDocModificado: this.props.facturaSel.Factura,
                          idCliente: this.props.facturaSel.cli.Codigo,
                          idVendedor: this.props.facturaSel.vend.Codigo,
                          porcentajeIva: this.props.facturaSel.PorcentajeIva});
        }
      });

    }else{      
      if(this.state.docModificado==='NDSRI'){ // NOTA DE DEBITO SRI
        
        if (!validarCampoString(this.props.numeroComprobante, 17)){
          alert('No ha especificado el No. de Documento a modificar correctamente.');
          return;
        }

        let establec = this.props.numeroComprobante.slice(0,3);
        let ptoEmision = this.props.numeroComprobante.slice(4,7);
        let secuencial = this.props.numeroComprobante.slice(8);

        this.props.cargar_NotaDebitoPorNumero(establec, ptoEmision, secuencial)
        .then(()=>{
          if (validarJSON(this.props.notaDebitoSel)){
            this.setState({ idDocModificado: this.props.notaDebitoSel.Debito,
                            idCliente: this.props.notaDebitoSel.cli.Codigo,
                            idVendedor: this.props.notaDebitoSel.vend.Codigo,
                            porcentajeIva: this.props.notaDebitoSel.PorcentajeIva===null?0:this.props.notaDebitoSel.PorcentajeIva});
          }
        });
      }else{ // NOTA DE DEBITO INTERNA
        
        if (!validarCampoString(this.state.notaDebitoInterna, 6)){
          alert('No ha especificado el No. de Documento a modificar correctamente.');
          return;
        }

        let idNotaDebito = this.state.notaDebitoInterna;
        this.props.cargar_NotaDebitoPorCodigo(idNotaDebito)
        .then(()=>{
          if (validarJSON(this.props.notaDebitoSel)){
            this.setState({ idDocModificado: this.props.notaDebitoSel.Debito,
                            idCliente: this.props.notaDebitoSel.cli.Codigo,
                            idVendedor: this.props.notaDebitoSel.vend.Codigo,
                            porcentajeIva: this.props.notaDebitoSel.PorcentajeIva===null?0:this.props.notaDebitoSel.PorcentajeIva});
          }
        });
      }
    }
  }

  getNotaCreditoById(tipoId){
    // Se puede consultar una N/C utilizando el Código (tipoId = 'Id') o el Número (tipoId = 'Nro')
    
    if (tipoId === 'Id'){
      let idNotaCred = this.state.idNotaCredito;
      if (!validarCampoString(idNotaCred, 6)){
        alert('No ha especificado el Cód. de Nota de Crédito correctamente.');
        return;
      }

      this.props.cargar_NotaCreditoPorCodigo(idNotaCred)
      .then(()=>{
        try {
          if (validarJSON(this.props.notaCreditoSel)){
            let total = parseFloat(this.props.notaCreditoSel.Valor===null?0:this.props.notaCreditoSel.Valor).toFixed(2);
            let valorIva = parseFloat(this.props.notaCreditoSel.Iva===null?0:this.props.notaCreditoSel.Iva).toFixed(2);
            let totalSinIva = parseFloat(this.props.notaCreditoSel.TotalSinIva===null?0:this.props.notaCreditoSel.TotalSinIva).toFixed(2);
            let totalConIva = parseFloat(total - totalSinIva - valorIva).toFixed(2);
            let porcentajeIva = parseFloat(this.props.notaCreditoSel.PorcentajeIva===null?0:this.props.notaCreditoSel.PorcentajeIva).toFixed(2);
            let tipoNotaCred = this.props.notaCreditoSel.EsInterna==='S'?'I':'S';
  
            this.seleccConceptosNCreditoPorTipo(tipoNotaCred);

            this.setState({
              operacion: 'M',
              fechaNotaCredito: moment(this.props.notaCreditoSel.Fecha, 'DD/MM/YYYY'),
              tipo: tipoNotaCred,
              concepto_sel: this.props.notaCreditoSel.Tipo,
              docModificado: '',              
              observacion: this.props.notaCreditoSel.Observacion,
              subtotalGravaIva: totalConIva,
              subtotalNoGravaIva: totalSinIva,
              porcentajeIva: porcentajeIva,
              valorIva,
              total
            });
            
            this.props.seleccionar_PuntoFacturacion(this.props.notaCreditoSel.PtoFacturacion);
          }  
        } catch (error) {
          alert(`Ocurrió un error al cargar la nota de crédito especificada. Error: ${error}`);
        }        
      });

    }else{
      if (!validarCampoString(this.props.numeroNotaCredito, 17)){
        alert('No ha especificado el No. de Nota de Crédito correctamente.');
        return;
      }

      let establec = this.props.numeroNotaCredito.slice(0,3);
      let ptoEmision = this.props.numeroNotaCredito.slice(4,7);
      let secuencial = this.props.numeroNotaCredito.slice(8);
      
      this.props.cargar_NotaCreditoPorNumero(establec, ptoEmision, secuencial)
      .then(()=>{
        try {
          if (validarJSON(this.props.notaCreditoSel)){
            let total = parseFloat(this.props.notaCreditoSel.Valor===null?0:this.props.notaCreditoSel.Valor).toFixed(2);
            let valorIva = parseFloat(this.props.notaCreditoSel.Iva===null?0:this.props.notaCreditoSel.Iva).toFixed(2);
            let totalSinIva = parseFloat(this.props.notaCreditoSel.TotalSinIva===null?0:this.props.notaCreditoSel.TotalSinIva).toFixed(2);
            let totalConIva = parseFloat(total - totalSinIva - valorIva).toFixed(2);
            let porcentajeIva = parseFloat(this.props.notaCreditoSel.PorcentajeIva===null?0:this.props.notaCreditoSel.PorcentajeIva).toFixed(2);
            let tipoNotaCred = this.props.notaCreditoSel.EsInterna==='S'?'I':'S';
  
            this.seleccConceptosNCreditoPorTipo(tipoNotaCred);
            
            this.setState({
              operacion: 'M',
              fechaNotaCredito: moment(this.props.notaCreditoSel.Fecha, 'DD/MM/YYYY'),
              tipo: tipoNotaCred,
              concepto_sel: this.props.notaCreditoSel.Tipo,
              docModificado: '',
              observacion: this.props.notaCreditoSel.Observacion,
              subtotalGravaIva: totalConIva,
              subtotalNoGravaIva: totalSinIva,
              porcentajeIva: porcentajeIva,
              valorIva,
              total,
              idNotaCredito: this.props.notaCreditoSel.Credito
            });

            this.props.seleccionar_PuntoFacturacion(this.props.notaCreditoSel.PtoFacturacion);
          }  
        } catch (error) {
          alert(`Ocurrió un error al cargar la nota de crédito especificada. Error: ${error}`);
        }        
      });      
    }  
  }

  cargarCatalogoConceptosNCredito(){
    return new Promise((resolve, reject) => {
      global_axios.get('/catalogos?tipo=otros&opcion=NCCLIENTE')
	    .then((response)=>{
        resolve(response.data);
      })
      .catch((err)=>{
        reject('Error al cargar datos del catálogo de conceptos de Nota de Crédito: ' + err);
      });
    });
  }

  guardarNotaCredito(){
    
    if (this.state.operacion==='M'){
      alert('La modificación de la Nota de Crédito no está permitida.');
      return;
    }

    let fechaNotaCredito = formatearFechaMoment_a_String(this.state.fechaNotaCredito);
    if (!validarFechaMomentEnFormatoString(fechaNotaCredito)){
      alert('La fecha de la Nota de Crédito es inválida.');
      return;
    }

    if (this.state.concepto_sel===null){
      alert('No ha seleccionado el concepto de la Nota de Crédito.');
      return;
    }

    if (this.state.concepto_sel==='VEN'){
      alert('El tipo de Nota de Crédito seleccionado no puede ser utilizado.');
      return;
    }

    if((!validarJSON(this.props.facturaSel)) && (!validarJSON(this.props.notaDebitoSel))){
      alert('No ha seleccionado la factura o nota de débito a modificar.');
      return;
    }

    this.calculoValores();

    if (!this.validarValoresEnNotaCredito()){      
      return;
    }    

    if(!validarCampoString(this.state.observacion, 1, 120)){
      alert('No ha especificado la observación.');
      return;
    }

    let validPermiso = validarPermisoAcceso(this.state.operacion, this.props.permiso);
    if (!validPermiso.esValido){
      alert(validPermiso.msg);
      return;
    }
    
    let fechaProceso = getFechaProcesoPorModulo('01');
    if (this.props.permiteCambioFProceso==='S'){      
      let validFProceso = validarFechaTransaccionSeleccionada(this.state.fechaNotaCredito, moment(fechaProceso, 'DD/MM/YYYY'), this.props.diasPermiteCambioFProceso);
      if(!validFProceso.esValida){
        alert(validFProceso.msg);
        return;
      }
    }
    
    this.props.cambiar_VisualizacionLoading(true);

    let notaCredito = {
      tipo: this.state.concepto_sel,
      fechaNotaCredito: fechaNotaCredito,
      codCliente: this.state.idCliente,
      totalNoGravaIva: (this.state.subtotalNoGravaIva===null?0:(this.state.subtotalNoGravaIva.toString().trim() ==='' || isNaN(Number(this.state.subtotalNoGravaIva))?0:this.state.subtotalNoGravaIva)),
      porcentajeIva: parseFloat(this.state.porcentajeIva),
      valorIva: parseFloat(this.state.valorIva),
      total: parseFloat(this.state.total),
      observacion: this.state.observacion,
      codVendedor: this.state.idVendedor,
      ptoFacturacion: this.state.tipo==='I'?null:this.props.puntoFacturacionSel,
      idFactura: (this.state.docModificado==='F'?this.state.idDocModificado:''),
      idNotaDebito: (this.state.docModificado!=='F'?this.state.idDocModificado:''),
      moneda: JSON.parse(getItemDatosSesion('moneda')).Moneda,
      dolar: JSON.parse(getItemDatosSesion('moneda')).Cotizacion,
      usuario: getItemDatosSesion('usuario')
    };

    global_axios({
      method: 'POST',
      url: '/notascredito',
      data: notaCredito
    })
    .then((response)=>{
      this.props.cambiar_VisualizacionLoading(false);
      alert('Se generó correctamente la Nota de Crédito No.: ' + response.data.nroNotaCredito);      
      this.limpiar();
    })
    .catch(error => {
      this.props.cambiar_VisualizacionLoading(false);
      alert(error.response?error.response.data.msg:error.message);
    });
  }

  anularNotaCredito(){
    if(this.state.operacion==='M' && validarJSON(this.props.notaCreditoSel)){
      let idNotaCredito = this.props.notaCreditoSel.Credito;
      let estadoNotaCredito = this.props.notaCreditoSel.Status;
      
      if(this.state.concepto_sel!==null){
        if(this.state.concepto_sel==='VEN'){
          alert('No puede proceder con la anulación de la Nota de Crédito de Devolución.');
          return;
        }
      }

      if(estadoNotaCredito==='A'){
        alert('No puede proceder con la anulación de la Nota de Crédito porque ya está Anulada.');
        return;
      }

      let validPermiso = validarPermisoAcceso(this.state.operacion, this.props.permiso);
      if (!validPermiso.esValido){
        alert(validPermiso.msg);
        return;
      }

      let anularNotaCred = window.confirm(`¿Está seguro de anular la Nota de Crédito: ${idNotaCredito}?`);
      if(!anularNotaCred){
        return;
      }else{
        this.props.cambiar_VisualizacionLoading(true);
    
        global_axios({
          method: 'DELETE',
          url: `/notascredito/${idNotaCredito}`,
          headers: {'idregaudit': this.props.idRegAudit}
        })
        .then(()=> {
          this.props.cambiar_VisualizacionLoading(false);      
          alert('La Nota de Crédito fue anulada correctamente.');          
          this.limpiar();
        })
        .catch((error)=>{
          this.props.cambiar_VisualizacionLoading(false);
          alert(error.response?error.response.data.msg:error.message);
        }); 
      }
     
    }else{
      alert('No ha especificado el número de Nota de Crédito a anular.');
    }
  }

  seleccConceptosNCreditoPorTipo(tipo){
    let conceptosNCPorTipo = [];
    this.state.conceptosNCredito.forEach((conceptoNC)=>{
      if (conceptoNC.Tipo === tipo){
        conceptosNCPorTipo.push({
          value: conceptoNC.Codigo,
          label: conceptoNC.Descripcion + '(' + conceptoNC.Codigo + ')'
        });
      }
    });

    this.setState({conceptosNCreditoPorTipo: conceptosNCPorTipo, concepto_sel: null});
  }

  verificarTipoNotaCreditoGravaIva(tipo){
    this.state.conceptosNCredito.forEach((conceptoNC)=>{      
      if (conceptoNC.Codigo === tipo){
        if (conceptoNC.GravaIva){
          this.setState({ permitirValorGravaIva: true });
        }else{
          this.setState({ permitirValorGravaIva: false });
        }
      }
    });
  }
  validarValoresEnNotaCredito(){
    let valoresOk = true;
    
    if(this.state.subtotalGravaIva!==null){
      if(this.state.subtotalGravaIva.trim().length!==0){
        if(isNaN(Number(this.state.subtotalGravaIva)) || Number(this.state.subtotalGravaIva)<=0){
          alert('El Subtotal Grava Iva es inválido.');
          valoresOk = false;
        }
      }
    }

    if(valoresOk){
      if(this.state.subtotalNoGravaIva!==null){
        if(this.state.subtotalNoGravaIva.trim().length!==0){
          if(isNaN(Number(this.state.subtotalNoGravaIva)) || Number(this.state.subtotalNoGravaIva)<=0){
            alert('El Subtotal No Grava Iva es inválido.');
            valoresOk = false;
          }
        }
      }
    }    

    if(valoresOk){
      if( (this.state.subtotalGravaIva===null?'':this.state.subtotalGravaIva).trim().length===0 &&
          (this.state.subtotalNoGravaIva===null?'':this.state.subtotalNoGravaIva).trim().length===0){
        alert('Debe especificar Subtotal Grava Iva y/o Subtotal No Grava Iva.');
        valoresOk = false;
      }
    }

    if(valoresOk){
      if(isNaN(Number(this.state.porcentajeIva))){
        alert('El Porcentaje de Iva es inválido.');
        valoresOk = false;
      }
    }

    if(valoresOk){
      if(isNaN(Number(this.state.valorIva))){
        alert('El Valor de Iva es inválido.');
        valoresOk = false;
      }
    }

    if(valoresOk){
      if(isNaN(Number(this.state.total)) || Number(this.state.total)<=0){
        alert('El Valor Total es inválido.');
        valoresOk = false;
      }
    }

    if(valoresOk){
      let total = parseFloat(this.state.total).toFixed(2);
      let saldoDocModif = 0;
      if (this.state.docModificado === 'F'){
        saldoDocModif = parseFloat(this.props.facturaSel.Saldo===null?0:this.props.facturaSel.Saldo).toFixed(2);
      }else{
        saldoDocModif = parseFloat(this.props.notaDebitoSel.Saldo===null?0:this.props.notaDebitoSel.Saldo).toFixed(2);
      }

      if (parseFloat(total)>parseFloat(saldoDocModif)){
        alert('El Valor Total no puede ser mayor que el Saldo del Documento a modificar.');
        valoresOk = false;
      }
    }

    return valoresOk;            
  }

  imprimirNotaCredito(){
    if (this.state.operacion==='M' && validarJSON(this.props.notaCreditoSel)){
      let idNotaCredito = this.props.notaCreditoSel.Credito;
      
      visualizarReporteEnPdf(`&rpt=71&param1=${idNotaCredito}`);
    }else{
      alert('No ha especificado el número de Nota de Crédito a imprimir.');
    }
  }

  render(){
    let tipoDocModif='',
        clienteDocModif='',
        vendedorDocModif='',
        fechaEmiDocModif='',
        valorDocModif='',
        porcIvaDocModif='',
        saldoDocModif='';
    
    let documentoRelacionado = '';
    
    if (this.state.operacion === 'G'){
      if (this.state.docModificado==='F'){      
        if (validarJSON(this.props.facturaSel)){
          tipoDocModif='FACTURA';
          clienteDocModif=`${this.props.facturaSel.cli.Codigo} - ${this.props.facturaSel.cli.Nombre}`
          vendedorDocModif=`${this.props.facturaSel.vend.Codigo}  - ${this.props.facturaSel.vend.Nombre}`;
          fechaEmiDocModif=this.props.facturaSel.Fecha;
          valorDocModif=parseFloat(this.props.facturaSel.Importe).toFixed(2).toString();
          porcIvaDocModif=this.props.facturaSel.PorcentajeIva===null?0:this.props.facturaSel.PorcentajeIva;
          saldoDocModif=parseFloat(this.props.facturaSel.Saldo===null?0:this.props.facturaSel.Saldo).toFixed(2).toString();
        }
      }else{
        if (this.state.docModificado==='NDSRI'){      
          if (validarJSON(this.props.notaDebitoSel)){
            tipoDocModif='NOTA DE DÉBITO SRI';
            clienteDocModif=`${this.props.notaDebitoSel.cli.Codigo} - ${this.props.notaDebitoSel.cli.Nombre}`;
            vendedorDocModif=`${this.props.notaDebitoSel.vend.Codigo} - ${this.props.notaDebitoSel.vend.Nombre}`;
            fechaEmiDocModif=this.props.notaDebitoSel.Fecha;
            valorDocModif=parseFloat(this.props.notaDebitoSel.Valor===null?0:this.props.notaDebitoSel.Valor).toFixed(2).toString();
            porcIvaDocModif=this.props.notaDebitoSel.PorcentajeIva===null?0:this.props.notaDebitoSel.PorcentajeIva;
            saldoDocModif=parseFloat(this.props.notaDebitoSel.Saldo===null?0:this.props.notaDebitoSel.Saldo).toFixed(2).toString();
          }
        }else{
          if (validarJSON(this.props.notaDebitoSel)){
            tipoDocModif='NOTA DE DÉBITO INTERNA';
            clienteDocModif=`${this.props.notaDebitoSel.cli.Codigo} - ${this.props.notaDebitoSel.cli.Nombre}`;
            vendedorDocModif=`${this.props.notaDebitoSel.vend.Codigo} - ${this.props.notaDebitoSel.vend.Nombre}`;
            fechaEmiDocModif=this.props.notaDebitoSel.Fecha;
            valorDocModif=parseFloat(this.props.notaDebitoSel.Valor===null?0:this.props.notaDebitoSel.Valor).toFixed(2).toString();
            porcIvaDocModif=this.props.notaDebitoSel.PorcentajeIva===null?0:this.props.notaDebitoSel.PorcentajeIva;
            saldoDocModif=parseFloat(this.props.notaDebitoSel.Saldo===null?0:this.props.notaDebitoSel.Saldo).toFixed(2).toString();
          }
        }
      }
    }else{
      if(validarJSON(this.props.notaCreditoSel.fact)){
        documentoRelacionado = `Factura: [Cód.: ${this.props.notaCreditoSel.fact.Factura} | Nro.: ${this.props.notaCreditoSel.fact.Establecimiento || ''}-${this.props.notaCreditoSel.fact.PtoEmision || ''}-${this.props.notaCreditoSel.fact.Nro || ''}]`;
      }
      if(validarJSON(this.props.notaCreditoSel.deb)){
        documentoRelacionado = `Nota de Débito: [Cód.: ${this.props.notaCreditoSel.deb.Debito} | Nro.: ${this.props.notaCreditoSel.deb.Establecimiento || ''}-${this.props.notaCreditoSel.deb.PtoEmision || ''}-${this.props.notaCreditoSel.deb.DebitoSri || ''}]`;
      }
    }

    return(
      <ContenedorForm porc_ancho={82}>
        <HeaderForm>
          <TituloForm>Nota de Crédito</TituloForm>
          <LabelCabecera>Últ. Nota Créd.: {this.state.secuencialNCredito}</LabelCabecera>
        </HeaderForm>
        <CuerpoForm>
          <ContainerEdit>
            <Row>
              <ContainerCol className='col-sm-2'>
                <LabelForm>Cód. Nota de Crédito:</LabelForm>
                <InputSearch tipoInput='text' nombre='idNotaCredito' placeholder='Cód. Nota de Crédito' valor={this.state.idNotaCredito}  maxLength={6}
                  func_CambiarValor={this.handleInputChange} func_BuscarValor={()=>{this.getNotaCreditoById('Id')}} func_OnFocus={this.limpiar}/>
              </ContainerCol>
              <ContainerCol className='col-sm-3'>
                <LabelForm>No. Nota de Crédito:</LabelForm>
                <NumeroComprobanteAlterno name='numNC' placeholder='No. Nota de Crédito' funcBuscarComprobante={()=>{this.getNotaCreditoById('Nro')}}
                  func_OnFocus={this.limpiar}/>
              </ContainerCol>
            </Row>
          </ContainerEdit>
          <Row>
            <ContainerCol className='col-sm-2'>
              <LabelForm>Cód. Nota de Crédito:</LabelForm>
              <InputText autoComplete='off' type='text' name='codNotaCredito' value={this.state.idNotaCredito}
                className='form-control input-sm' placeholder='Cód. Nota de Crédito' readOnly='true'/>
            </ContainerCol>
            <ContainerCol className='col-sm-2'>
              <LabelForm>Fecha:</LabelForm>
              <PickerFecha fechaSeleccionada={this.state.fechaNotaCredito} disabled={!(this.props.permiteCambioFProceso==='S')}
                func_onChange={(fecha)=>{this.setState({fechaNotaCredito: fecha})}}/>
            </ContainerCol>
            <ContainerCol className='col-sm-2'>
              <LabelForm>Tipo Nota Crédito:</LabelForm>
              <LabelForm className='radio-inline'>
                <input type='radio' name='tipo' value='I' checked={this.state.tipo==='I'} onChange={this.handleInputChange}/>
                Interna</LabelForm>
              <LabelForm className='radio-inline'>
                <input type='radio' name='tipo' value='S' checked={this.state.tipo==='S'} onChange={this.handleInputChange}/>
                SRI</LabelForm>
            </ContainerCol>
            <ContainerCol className='col-sm-4'>
              <LabelForm>Concepto:</LabelForm>
              <ReactSelect options={ this.state.conceptosNCreditoPorTipo } value={this.state.concepto_sel} 
                func_onChange={(value)=>{ if(Array.isArray(value)){value=null};
                                          let conceptoSel = (value===null)?null:value.value;                                          
                                          if(conceptoSel!==null){
                                            this.verificarTipoNotaCreditoGravaIva(conceptoSel);
                                          }
                                          this.setState({concepto_sel: conceptoSel});
                                        }
                              }/>
            </ContainerCol>
            <ContainerCol className='col-sm-2'>
              <LabelForm>Pto. Facturación:</LabelForm>
              <PuntoFacturacion disabled={this.state.tipo==='I'}/>
            </ContainerCol>
          </Row>
          <Row isInvisible={this.state.operacion==='M'?true:false} margen_arriba={15}>
            <ContainerCol className='col-sm-2'>
              <LabelForm>Documento a Modificar:</LabelForm>
              <div className='radio'>
                <LabelForm><input type='radio' name="docModificado" value="F" checked={this.state.docModificado==="F"} onChange={this.handleInputChange}/>
                  Factura</LabelForm>
              </div>
              <div className='radio'>
                <LabelForm><input type="radio" name="docModificado" value="NDSRI" checked={this.state.docModificado==="NDSRI"} onChange={this.handleInputChange}/>
                  N. Débito SRI</LabelForm>
              </div>
              <div className='radio'>
                <LabelForm><input type="radio" name="docModificado" value="NDI" checked={this.state.docModificado==="NDI"} onChange={this.handleInputChange}/>
                  N. Débito Interna</LabelForm>
              </div> 
            </ContainerCol>
            <ContainerCol className='col-sm-3'>
              <LabelForm>Número Documento a Modificar:</LabelForm>
              <ContenedorDocModif isVisible={this.state.docModificado!=='NDI'?true:false}>
                <NumeroComprobante placeholder={this.state.docModificado==='F'?'No. Factura':(this.state.docModificado==='NDSRI'?'No. Nota Débito':'')}
                  funcBuscarComprobante={this.getDocumentoAModificar}
                  func_OnFocus={()=>{this.inicializarDocumentos(false)}}/>
              </ContenedorDocModif>
              <ContenedorDocModif isVisible={this.state.docModificado==='NDI'?true:false}>
                <InputSearch autoComplete='off' tipoInput='text' nombre='notaDebitoInterna' placeholder='Cód. Nota de Débito' valor={this.state.notaDebitoInterna}  maxLength={6}
                  func_CambiarValor={this.handleInputChange} func_BuscarValor={this.getDocumentoAModificar} func_OnFocus={()=>{this.inicializarDocumentos(false)}}/>
              </ContenedorDocModif>
            </ContainerCol>
            <ContainerCol className='col-sm-7'>
              <LabelForm>Información Documento a Modificar:</LabelForm>
              <ContenedorInfoDocModif className='col-sm-12'>
                <Row>
                  <ContainerCol className='col-sm-2'>
                    <LabelForm>Tipo Dcto:</LabelForm>
                  </ContainerCol>
                  <ContainerCol className='col-sm-2'>
                    <LabelValor>{tipoDocModif}</LabelValor>
                  </ContainerCol>
                  <ContainerCol className='col-sm-2'>
                    <LabelForm>Cliente:</LabelForm>
                  </ContainerCol>
                  <ContainerCol className='col-sm-6'>
                    <LabelValor>{clienteDocModif}</LabelValor>
                  </ContainerCol>
                </Row>
                <Row>
                  <ContainerCol className='col-sm-2'>
                    <LabelForm>F. Emisión:</LabelForm>
                  </ContainerCol>
                  <ContainerCol className='col-sm-2'>
                    <LabelValor>{fechaEmiDocModif}</LabelValor>
                  </ContainerCol>
                  <ContainerCol className='col-sm-2'>
                    <LabelForm>Vendedor:</LabelForm>
                  </ContainerCol>
                  <ContainerCol className='col-sm-6'>
                    <LabelValor>{vendedorDocModif}</LabelValor>
                  </ContainerCol>
                </Row>
                <Row>
                  <ContainerCol className='col-sm-2'>
                    <LabelForm>Valor:</LabelForm>
                  </ContainerCol>
                  <ContainerCol className='col-sm-2'>
                    <LabelValor>{valorDocModif?formatearNumeroDecimal(valorDocModif):''}</LabelValor>
                  </ContainerCol>
                  <ContainerCol className='col-sm-2'>
                    <LabelForm>% Iva:</LabelForm>
                  </ContainerCol>
                  <ContainerCol className='col-sm-2'>
                    <LabelValor>{validarCampoString(porcIvaDocModif,1,2)?porcIvaDocModif+'%':''}</LabelValor>
                  </ContainerCol>                                      
                  <ContainerCol className='col-sm-2'>
                    <LabelForm>Saldo:</LabelForm>
                  </ContainerCol>
                  <ContainerCol className='col-sm-2'>
                    <LabelValor>{saldoDocModif?formatearNumeroDecimal(saldoDocModif):''}</LabelValor>
                  </ContainerCol>
                </Row>
              </ContenedorInfoDocModif>
            </ContainerCol>
          </Row>
          <Row isInvisible={this.state.operacion==='M'?false:true} margen_arriba={15}>
            <ContainerCol className='col-sm-2'>
              <LabelKey>Estado:</LabelKey>
              <LabelValor>{validarJSON(this.props.notaCreditoSel.est)?`${this.props.notaCreditoSel.est.Estado} - ${this.props.notaCreditoSel.est.Nombre}`:''}</LabelValor>
            </ContainerCol>
            <ContainerCol className='col-sm-4'>
              <LabelKey>Cliente:</LabelKey>
              <LabelValor>{validarJSON(this.props.notaCreditoSel.cli)?`${this.props.notaCreditoSel.cli.Codigo} - ${this.props.notaCreditoSel.cli.Nombre}`:''}</LabelValor>
            </ContainerCol>
            <ContainerCol className='col-sm-4'>
              <LabelKey>Doc. Relacionado:</LabelKey>
              <LabelValor>{documentoRelacionado}</LabelValor>
            </ContainerCol>
            <ContainerCol className='col-sm-2'>
              <LabelKey>Devolución:</LabelKey>
              <LabelValor>{validarCampoString(this.props.notaCreditoSel.Devolucion, 6)?this.props.notaCreditoSel.Devolucion:''}</LabelValor>
            </ContainerCol>
          </Row>
          <Row margen_arriba={10}>
            <ContainerCol className='col-sm-2'>
              <LabelForm>Subtotal Grava Iva:</LabelForm>
              <InputText type='text' name='subtotalGravaIva' disabled={!this.state.permitirValorGravaIva} value={this.state.subtotalGravaIva===null?'':this.state.subtotalGravaIva} onChange={this.handleInputChange} onBlur={()=>{this.calculoValores();}}/>
            </ContainerCol>
            <ContainerCol className='col-sm-2'>
              <LabelForm>Subtotal No Grava Iva:</LabelForm>
              <InputText type='text' name='subtotalNoGravaIva' value={this.state.subtotalNoGravaIva===null?'':this.state.subtotalNoGravaIva} onChange={this.handleInputChange} onBlur={()=>{this.calculoValores();}}/>
            </ContainerCol>
            <ContainerCol className='col-sm-1'>
              <LabelForm>% Iva:</LabelForm>
              <InputText type='text' name='porcentajeIva' value={this.state.porcentajeIva===null?'':this.state.porcentajeIva} disabled={true}/>
            </ContainerCol>
            <ContainerCol className='col-sm-1'>
              <LabelForm>Valor Iva:</LabelForm>
              <InputText type='text' name='valorIva' value={this.state.valorIva===null?'':this.state.valorIva} disabled={true}/>
            </ContainerCol>
            <ContainerCol className='col-sm-2'>
              <LabelForm>Total:</LabelForm>
              <InputText type='text' name='total' value={this.state.total===null?'':this.state.total} disabled={true}/>
            </ContainerCol>
            <ContainerCol className='col-sm-4'>
              <LabelForm>Observación:</LabelForm>
              <InputText type='text' name='observacion' value={this.state.observacion} onChange={this.handleInputChange}/>
            </ContainerCol>
          </Row>
          <Row>
            <ContenedorBotones className='col-sm-12'>
              <div className='btn-group pull-right'>
                <button type='button' className='btn btn-primary btn-sm' onClick={this.guardarNotaCredito}
                  disabled={this.state.operacion==='M'?true:false}><i className='fa fa-floppy-o fa-lg'/> Guardar</button>
                <button type='button' className='btn btn-info btn-sm' onClick={this.imprimirNotaCredito}><i className='fa fa-print fa-lg'/> Imprimir</button>
                <button type='button' className='btn btn-danger btn-sm' onClick={this.anularNotaCredito}
                  disabled={this.state.operacion==='M'?false:true}><i className='fa fa-minus-circle fa-lg'/> Anular</button>
                <button type='button' className='btn btn-sm' onClick={this.limpiar}><i className='fa fa-trash-o fa-lg'/> Limpiar</button>
              </div>
            </ContenedorBotones>
          </Row>
        </CuerpoForm>
      </ContenedorForm>
    )
  }  
}

const mapStateToProps = state =>{
  return {  isVisibleLoading: state.ui.isVisibleLoading,
            permiso: state.sesion.valoresSesionForm.Permiso,
            idRegAudit: state.sesion.valoresSesionForm.IdRegAudit,
            permiteCambioFProceso: state.sesion.valoresSesionForm.CambioFechaProceso,
            diasPermiteCambioFProceso: state.sesion.valoresSesionForm.CantidadDias,
            numeroComprobante: state.generales.numComprobSel,
            puntoFacturacionSel: state.ventas.ptoFacturacionSel,
            facturaSel: state.ventas.facturaSel,
            notaCreditoSel: state.clientes.notaCreditoSel,
            notaDebitoSel: state.clientes.notaDebitoSel,
            puntosFacturacion: state.ventas.puntosFact,
            numeroNotaCredito: state.generales.numComprobAlternoSel
  };
};

const mapDispatchToProps = ((dispatch) => {  
  return bindActionCreators({ generar_LogAuditoriaIngresoForm,
                              generar_LogAuditoriaSalidaForm,
                              cambiar_VisualizacionLoading,
                              cargar_Factura,
                              cargar_NotaCreditoPorCodigo,
                              cargar_NotaCreditoPorNumero,
                              cargar_NotaDebitoPorCodigo,
                              cargar_NotaDebitoPorNumero,
                              inicializarFactura,
                              inicializarNotaCredito,
                              inicializarNotaDebito,
                              seleccionar_NumeroComprobante,
                              seleccionar_NumeroComprobanteAlterno,
                              seleccionar_PuntoFacturacion
                            }, dispatch)
});

export default connect (mapStateToProps, mapDispatchToProps)(FormCli04);